export const userConfig = {
  avatar: 'https://avatars.githubusercontent.com/u/66712044?v=4',
  firstName: 'Diego',
  lastName: 'Parra',
  username: 'g0d13',
  about: `Making every line count`,
  phoneNumber: '',
  country: 'Mexico',
  state: 'Puebla',
  university: 'ITST'
}
